import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

// Gelen Kutum derin bağlantıları (müşteri geri bildirimi 2026-10-28 — "karta tıklayınca işin kendisi açılsın"): hedef sayfa
// sorgu parametresini (ör. ?responseId=, ?objectionId=, ?period=&record=) okur ve o kaydın formunu / karar modalını / onay
// diyaloğunu açar. `clear` diyalog kapanınca parametreleri geçmişe yeni giriş eklemeden (history.replace) siler: geri tuşu
// kapatılmış diyaloğu yeniden açmaz, sayfa yenilenince aynı kayıt tekrar açılmaz. Diğer sorgu parametreleri korunur.
//
// names: okunacak parametre adları (sabit dizi). Dönüş: { values: { [ad]: string|null }, clear }.
export default function useDeepLinkParams(names) {
  const location = useLocation();
  const history = useHistory();
  const key = names.join('|');

  const values = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return key.split('|').reduce((acc, name) => ({ ...acc, [name]: params.get(name) || null }), {});
  }, [location.search, key]);

  const clear = useCallback(() => {
    const params = new URLSearchParams(location.search);
    const list = key.split('|');
    if (!list.some((name) => params.has(name))) return;
    list.forEach((name) => params.delete(name));
    const search = params.toString();
    history.replace({ pathname: location.pathname, search: search ? `?${search}` : '' });
  }, [history, location.pathname, location.search, key]);

  return { values, clear };
}
